import DOMPurify from 'dompurify';
import parse from 'html-react-parser';
export var safeRenderHTML = function (html) {
    if (!html)
        return;
    var cleanMarkup = DOMPurify.sanitize(html);
    return parse(cleanMarkup);
};
export var getCompactTagVersion = function (tag) {
    if (!tag)
        return '';
    var versionRegex = /^\d+\.\d+\.\d+/;
    var match = tag.match(versionRegex);
    return match ? match[0] : tag;
};
